import { useState } from 'react';
import ConfettiExplosion from 'react-confetti-explosion';
import { motion } from 'framer-motion';

import { Images } from '../../../constants/images';
import { SVGIconType } from '../../../constants/svgIcon';
import { Profile } from '../../../models/UserStore';
import { AvatarNode, SvgIcon } from '../../Molecules';

import styles from './GameEndVSResultGroup.module.css';

export type GameEndVSResultGroupProps = {
  currentUserProfile: Profile;
  currentUserScore: number;
  currentUserDuration: string;
  opponentUserProfile?: Profile;
  opponentUserScore?: number;
  opponentUserDuration?: string;
  withAIBadge?: boolean;
};

const PlayerSide = ({
  profile,
  score,
  duration,
  isWinner,
  isShowConfetti,
  isTutor,
  onCompleteConfetti,
  withAIBadge = false,
}: {
  profile: Profile;
  score: number;
  duration: string;
  isWinner: boolean;
  isShowConfetti: boolean;
  isTutor: boolean;
  onCompleteConfetti?: () => void;
  withAIBadge?: boolean;
}) => (
  <div className={`${styles.side} ${isWinner ? styles.winner : styles.loser}`}>
    {isShowConfetti && (
      <ConfettiExplosion
        duration={2200}
        force={0.4}
        onComplete={onCompleteConfetti}
        zIndex={9999} /* LOADING_SPINNER_ZINDEX */
        colors={['#ff577f70', '#ff884b', '#ffd38470', '#fff9b0', '#3498db70']}
      />
    )}
    <div className={styles.avatar}>
      <AvatarNode profile={profile} size={96} />
      {withAIBadge && (
        <div className={styles.aiBadge}>
          <span className={styles.aiBadgeLabel}>AI</span>
        </div>
      )}
    </div>
    <div className={styles.info}>
      <div
        className={`${styles.profileName} ${
          isWinner ? styles.blackColor : styles.whiteColor
        }`}
      >
        {profile.name}
      </div>
      <div
        className={`${styles.recordRow} ${
          isWinner ? styles.blackColor : styles.whiteColor
        }`}
      >
        {/* <p className={styles.recordLabel}>This Record:</p> */}
        <div>
          <SvgIcon name={SVGIconType.Score} width={24} height={24} />
          <span>{Math.floor(score)}</span>
        </div>
        <div>
          <SvgIcon name={SVGIconType.Timer} width={24} height={24} />
          <span>{duration}</span>
        </div>
      </div>
      {/* <div className={styles.stats}>⭐️⭐️⭐️⭐️⭐️</div> */}
    </div>
    {isWinner && !isTutor && (
      <>
        <motion.img
          src={Images.CrownEffect}
          alt="Crown Effect"
          className={styles.crownEffect}
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 5, ease: 'linear' }}
        />
        <img src={Images.Crown} alt="Crown" className={styles.crownImage} />

        <div className={styles.winText}>Win</div>
      </>
    )}
  </div>
);

export const GameEndVSResultGroup = (props: GameEndVSResultGroupProps) => {
  const {
    currentUserProfile,
    currentUserScore,
    currentUserDuration,
    opponentUserProfile,
    opponentUserScore,
    opponentUserDuration,
    withAIBadge,
  } = props;
  let isCurrentUserWin = false;
  let isBoomFirework = false;
  let isTutor = false;
  if (
    opponentUserProfile !== undefined &&
    opponentUserScore !== undefined &&
    opponentUserDuration !== undefined
  ) {
    isCurrentUserWin =
      currentUserScore > opponentUserScore ||
      (currentUserScore === opponentUserScore &&
        currentUserDuration < opponentUserDuration);
    isBoomFirework = isCurrentUserWin;
  } else {
    isCurrentUserWin = true;
    isBoomFirework = currentUserScore > 75;
    isTutor = true;
  }

  const [isExploding, setIsExploding] = useState(isBoomFirework);

  return (
    <div
      className={styles.container}
      style={{
        paddingTop: `${opponentUserProfile === undefined ? '3rem' : '6rem'}`,
        paddingBottom: `${opponentUserProfile === undefined ? '0rem' : '0rem'}`,
      }}
    >
      {(isCurrentUserWin ||
        (opponentUserProfile === undefined && currentUserScore > 80)) && (
        <div className={styles.confettiBoom}>
          {/* <Confetti
            mode="boom"
            x={opponentUserProfile === undefined ? 0.5 : 0.2}
            y={0.1}
            particleCount={25}
            deg={270}
            shapeSize={16}
            spreadDeg={45}
            effectInterval={2000}
            effectCount={100}
            colors={[
              '#ff577f70',
              '#ff884b',
              '#ffd38470',
              '#fff9b0',
              '#3498db70',
            ]}
          /> */}
        </div>
      )}

      <PlayerSide
        profile={currentUserProfile}
        score={currentUserScore}
        duration={currentUserDuration}
        isWinner={isCurrentUserWin}
        isShowConfetti={isExploding}
        isTutor={isTutor}
        onCompleteConfetti={() => {
          setIsExploding(false);
          setTimeout(() => {
            setIsExploding(true);
          }, 500);
        }}
      />

      {opponentUserProfile !== undefined &&
      opponentUserScore !== undefined &&
      opponentUserDuration !== undefined ? (
        <>
          <div className={styles.vs}>VS</div>

          <PlayerSide
            profile={opponentUserProfile}
            score={opponentUserScore}
            duration={opponentUserDuration}
            isWinner={!isCurrentUserWin}
            isShowConfetti={false}
            isTutor={isTutor}
            withAIBadge={withAIBadge}
          />
        </>
      ) : (
        <></>
      )}
    </div>
  );
};
